export const CORPORATE_PROFILE_KEY = 'stratosphere_corporate_profile';

export const FOCUS_MATERIALS = [
  'Lithium',
  'Cobalt',
  'Nickel',
  'Graphite',
  'Rare Earth Elements',
];

export const COMPANY_TYPES = [
  'E2W OEM',
  'E4W OEM',
  'Cell Manufacturer',
  'Component Supplier',
];

export const BATTERY_CHEMISTRIES = ['LFP', 'NMC', 'NCA', 'Sodium-Ion'];

export const MOTOR_TYPES = ['PMSM', 'BLDC', 'Induction', 'Hub Motor'];

export const CHINA_RAW_OPTIONS = ['Yes', 'No', "Don't Know"];

export const ALERT_CHANNELS = ['Email', 'WhatsApp', 'SMS'];

export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const createSupplierRows = () =>
  FOCUS_MATERIALS.map((material) => ({
    material,
    sourceCountry: '',
    volumeSharePercent: '',
    domesticRawFromChina: '',
  }));

export const initialCorporateFormState = () => ({
  companyLegalName: '',
  companyMakes: '',
  batteryChemistries: [],
  factoryStates: '',
  annualUnitsLastFY: '',
  plannedProductionNextQuarter: '',
  avgBatteryPackKwh: '',
  motorType: '',
  totalAnnualMaterialCostCr: '',
  quarterlyMaterialBudgetCr: '',
  fxBudgetRateUsd: '',
  approximateSpendPerMaterial: '',
  materialsInrVsUsd: '',
  suppliers: createSupplierRows(),
  leadTimeDays: '',
  safetyStockPerMaterial: '',
  contractVsSpotPercent: '',
  competitors: ['', '', '', '', ''],
  dashboardUsers: [{ name: '', designation: '', alertChannel: 'Email' }],
  weeklyBriefDay: 'Monday',
  weeklyBriefTime: '09:00',
});

export function loadCorporateProfile() {
  try {
    const saved = localStorage.getItem(CORPORATE_PROFILE_KEY);
    if (!saved) return null;
    const parsed = JSON.parse(saved);
    const base = initialCorporateFormState();
    return {
      ...base,
      ...parsed,
      suppliers: parsed.suppliers?.length ? parsed.suppliers : base.suppliers,
      dashboardUsers: parsed.dashboardUsers?.length
        ? parsed.dashboardUsers
        : base.dashboardUsers,
      competitors:
        parsed.competitors?.length === 5 ? parsed.competitors : base.competitors,
    };
  } catch {
    return null;
  }
}

export function saveCorporateProfile(profile) {
  localStorage.setItem(CORPORATE_PROFILE_KEY, JSON.stringify(profile));
}

export function parseChinaExposurePercent(supplierRow) {
  const raw = `${supplierRow?.volumeSharePercent || ''} ${supplierRow?.sourceCountry || ''}`;
  const match = raw.match(/(\d{1,3})\s*%/);
  if (match) return Math.min(100, Number(match[1]));
  if (/china/i.test(raw) && !/\d/.test(raw)) return 70;
  return null;
}

export function getSupplierForMaterial(profile, materialName) {
  return profile?.suppliers?.find((s) => s.material === materialName);
}

/** Average China-linked % across supplier rows (from profile form). */
export function getAverageChinaExposurePercent(profile) {
  if (!profile?.suppliers?.length) return null;
  const values = profile.suppliers
    .map(parseChinaExposurePercent)
    .filter((v) => v != null);
  if (!values.length) return null;
  return Math.round(values.reduce((a, b) => a + b, 0) / values.length);
}

export function formatMaterialCostCr(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `₹${n.toLocaleString('en-IN')} Cr`;
}
